module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp6-9ba744e1fcbc7a35027dc16ef8b7aa86.jpg";